<template>
  <div class="km-home">
    <!-- 英雄轮播区 -->
    <global-carousel></global-carousel>

    <!-- 产品展示区 -->
    <section class="home-section products-section">
      <div class="k-container">
        <div class="section-header">
          <div class="section-tag">Our Products</div>
          <h2 class="section-title">核心产品系列</h2>
          <p class="section-desc">专注电容器自动化设备研发，为您提供完整的生产线解决方案</p>
        </div>
        <prod-box></prod-box>
        <div class="section-action">
          <a class="btn-view-all" @click="goToProducts">
            查看全部产品
            <Icon type="ios-arrow-forward" size="16" />
          </a>
        </div>
      </div>
    </section>

    <!-- 关于我们区 -->
    <section class="home-section about-section">
      <div class="k-container">
        <about-box></about-box>
      </div>
    </section>

    <!-- 联系我们区 -->
    <section class="home-section contact-section">
      <div class="k-container">
        <contact-box></contact-box>
      </div>
    </section>
  </div>
</template>

<script>
import ProdBox from '../products/prod-box.vue';
import ContactBox from '../contact/index.vue';
import AboutBox from '../About.vue';
import GlobalCarousel from '@/components/GlobalCarousel/GlobalCarousel';

export default {
  data() {
    return {};
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  components: {
    ProdBox,
    ContactBox,
    AboutBox,
    GlobalCarousel,
  },
  methods: {
    goToProducts() {
      this.$router.push('/prod-list');
    },
  },
};
</script>

<style scoped lang="less">
.km-home {
  width: 100%;
}

/* 通用区块 */
.home-section {
  padding: 72px 0;
}

.products-section {
  background: var(--bg-secondary);
}

.about-section {
  background: var(--bg-primary);
}

.contact-section {
  background: var(--bg-secondary);
}

/* 查看全部按钮 */
.section-action {
  text-align: center;
  margin-top: 40px;
}

.btn-view-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 13px 32px;
  background: var(--primary);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-decoration: none;
  box-shadow: var(--shadow-primary);

  &:hover {
    background: var(--primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(0, 86, 179, 0.35);
    color: #ffffff;
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .home-section {
    padding: 48px 0;
  }
}

@media (max-width: 480px) {
  .home-section {
    padding: 36px 0;
  }
}
</style>
